import {
  //
  ADD_TOOLS,
  ADD_TOOLS_FAILURE,
  ADD_TOOLS_SUCCESS,
  //
  DELETE_TOOLS,
  DELETE_TOOLS_FAILURE,
  DELETE_TOOLS_SUCCESS,
  //
  EDIT_TOOLS,
  EDIT_TOOLS_FAILURE,
  EDIT_TOOLS_SUCCESS,
  //
  FETCH_TOOLS,
  FETCH_TOOLS_FAILURE,
  FETCH_TOOLS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  GET_RESIDENT_TOOL_DATA,
  GET_RESIDENT_TOOL_DATA_FAILURE,
  GET_RESIDENT_TOOL_DATA_SUCCESS,
  //
  SET_RESIDENT_TOOL_DATA_FILTERS,
  //
  UPDATE_TOOL_SEQUENCE,
  UPDATE_TOOL_SEQUENCE_FAILURE,
  UPDATE_TOOL_SEQUENCE_SUCCESS,
  //
  SEARCH_TOOLS,
  SEARCH_TOOLS_FAILURE,
  SEARCH_TOOLS_SUCCESS,
  //
  GET_TOOL_SNAPSHOTS,
  GET_TOOL_SNAPSHOTS_FAILURE,
  GET_TOOL_SNAPSHOTS_SUCCESS,
} from "./constants";

// List
export const fetchTools = (payload, onSuccess) => ({
  type: FETCH_TOOLS,
  payload,
  onSuccess,
});
export const fetchToolsSuccess = (payload) => ({
  type: FETCH_TOOLS_SUCCESS,
  payload,
});
export const fetchToolsFailure = (payload) => ({
  type: FETCH_TOOLS_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addTools = (payload, onAdd) => ({
  type: ADD_TOOLS,
  payload,
  onAdd,
});
export const addToolsSuccess = (payload) => ({
  type: ADD_TOOLS_SUCCESS,
  payload,
});
export const addToolsFailure = (payload) => ({
  type: ADD_TOOLS_FAILURE,
  payload,
});
// EDIT
export const editTools = (payload, onEdit) => ({
  type: EDIT_TOOLS,
  payload,
  onEdit,
});
export const editToolsSuccess = (payload, onEdit) => ({
  type: EDIT_TOOLS_SUCCESS,
  payload,
});
export const editToolsFailure = (payload) => ({
  type: EDIT_TOOLS_FAILURE,
  payload,
});
// DELETE
export const deleteTools = (payload, onDelete) => ({
  type: DELETE_TOOLS,
  payload,
  onDelete,
});
export const deleteToolsSuccess = (payload) => ({
  type: DELETE_TOOLS_SUCCESS,
  payload,
});
export const deleteToolsFailure = (payload) => ({
  type: DELETE_TOOLS_FAILURE,
  payload,
});
// Get Resident Tool Data
export const getResidentToolData = (payload, onSuccess) => ({
  type: GET_RESIDENT_TOOL_DATA,
  payload,
  onSuccess,
});
export const getResidentToolDataSuccess = (payload) => ({
  type: GET_RESIDENT_TOOL_DATA_SUCCESS,
  payload,
});
export const getResidentToolDataFailure = (payload) => ({
  type: GET_RESIDENT_TOOL_DATA_FAILURE,
  payload,
});
// Set Resident Tool Data Filters
export const setResidentToolDataFilters = (payload) => ({
  type: SET_RESIDENT_TOOL_DATA_FILTERS,
  payload,
});

// Update Tool Sequence
export const updateToolSequence = (payload, onSuccess) => ({
  type: UPDATE_TOOL_SEQUENCE,
  payload,
  onSuccess,
});
export const updateToolSequenceSuccess = (payload) => ({
  type: UPDATE_TOOL_SEQUENCE_SUCCESS,
  payload,
});
export const updateToolSequenceFailure = (payload) => ({
  type: UPDATE_TOOL_SEQUENCE_FAILURE,
  payload,
});
// Search Tools
export const searchTools = (payload, onSuccess) => ({
  type: SEARCH_TOOLS,
  payload,
  onSuccess,
});
export const searchToolsSuccess = (payload) => ({
  type: SEARCH_TOOLS_SUCCESS,
  payload,
});
export const searchToolsFailure = (payload) => ({
  type: SEARCH_TOOLS_FAILURE,
  payload,
});
// Get Tool Snapshots
export const getToolSnapshots = (payload, onSuccess) => ({
  type: GET_TOOL_SNAPSHOTS,
  payload,
  onSuccess,
});
export const getToolSnapshotsSuccess = (payload) => ({
  type: GET_TOOL_SNAPSHOTS_SUCCESS,
  payload,
});
export const getToolSnapshotsFailure = (payload) => ({
  type: GET_TOOL_SNAPSHOTS_FAILURE,
  payload,
});
